import { Box, Typography } from '@material-ui/core';
import React from 'react';

export const OperationalTierTooltip = ({ tier }) => {
  return (
    <Box>
      <Typography variant="body1">
        <u>
          <strong>Features</strong>
        </u>
      </Typography>
      {tier.features.map((feature, i) => (
        <Typography key={i} variant="body2">{`${
          i + 1
        }. ${feature}`}</Typography>
      ))}
    </Box>
  );
};
